let interopAccountId: string | null = null;
let interopAccountIdPromise: Promise<string> | null = null;
let registrationId = 0;

export function setInteropAccountId(idPromise: Promise<string>) {
  const currentRegistrationId = ++registrationId;

  interopAccountId = null;
  interopAccountIdPromise = idPromise.then((id) => {
    if (currentRegistrationId === registrationId) {
      interopAccountId = id;
    }

    return id;
  });
}

export function getInteropAccountId(): string | null {
  return interopAccountId;
}

export function getInteropAccountIdPromise(): Promise<string> | null {
  return interopAccountIdPromise;
}
